import { Controller } from "@hotwired/stimulus"

// Paginates a list of activity log items, showing `perPage` at a time.
// Clicking the prev/next chevron buttons walks through pages in memory —
// all items are rendered server-side; only visibility toggles.
export default class extends Controller {
  static targets = ["item", "prev", "next"]
  static values = {
    perPage: { type: Number, default: 3 },
    page: { type: Number, default: 0 }
  }

  connect() {
    this.render()
  }

  next() {
    if (this.canGoNext) {
      this.pageValue++
      this.render()
    }
  }

  prev() {
    if (this.canGoPrev) {
      this.pageValue--
      this.render()
    }
  }

  render() {
    const start = this.pageValue * this.perPageValue
    const end = start + this.perPageValue

    this.itemTargets.forEach((item, index) => {
      const visible = index >= start && index < end
      item.classList.toggle("hidden", !visible)
    })

    if (this.hasPrevTarget) this.updateButton(this.prevTarget, this.canGoPrev)
    if (this.hasNextTarget) this.updateButton(this.nextTarget, this.canGoNext)
  }

  updateButton(button, enabled) {
    if (!button) return
    button.disabled = !enabled
    button.classList.toggle("opacity-30", !enabled)
    button.classList.toggle("cursor-not-allowed", !enabled)
    button.classList.toggle("hover:text-gray-600", enabled)
  }

  get totalPages() {
    return Math.max(1, Math.ceil(this.itemTargets.length / this.perPageValue))
  }

  get canGoPrev() {
    return this.pageValue > 0
  }

  get canGoNext() {
    return this.pageValue < this.totalPages - 1
  }
}
